'use client'

import { paths } from '@/config/paths'
import { Panel } from '@/ui/atoms/panel/Panel'
import { TabSelectorLink } from '@/ui/atoms/tab-selector/TabSelector'
import { Typography } from '@/ui/atoms/typography/Typography'
import { PageLayout } from '@/ui/layouts/PageLayout'
import { cn } from '@/ui/utils/style'
import { usePathname } from 'next/navigation'

const tabs = [
  {
    label: 'Cross-chain',
    href: paths.bridge,
  },
  {
    label: 'HyperCore',
    href: paths.bridgeHyperCore,
  },
]

export default function BridgeLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const isHyperCore = pathname === paths.bridgeHyperCore

  return (
    <PageLayout className="mt-8">
      <div className="flex justify-center">
        <div className="w-full max-w-xl">
          <Panel.Wrapper className={cn('flex flex-col gap-8 p-4 md:p-6')}>
            <div className="flex max-w-xl flex-col items-start gap-4">
              <Typography variant="h1" className="lg:text-4xl" gradient>
                Bridge
              </Typography>
            </div>
            <div className="flex flex-col gap-8">
              <TabSelectorLink tabs={tabs} currentPath={pathname} />
              <Typography variant="p" className="text-muted-foreground">
                {isHyperCore ? (
                  <>
                    This widget uses the official{' '}
                    <a
                      href="https://hyperliquid.gitbook.io/hyperliquid-docs/for-developers/api/exchange-endpoint"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-secondary-foreground underline transition-colors hover:text-foreground"
                    >
                      HyperCore transfer API
                    </a>
                    , and is an easy way to transfer assets between HyperCore and HyperEVM
                  </>
                ) : (
                  <>
                    Transfer from all EVM chains directly to HyperEVM - or even into HypurrFi deposit positions
                    directly.
                  </>
                )}
              </Typography>
            </div>
            {children}
          </Panel.Wrapper>
        </div>
      </div>
    </PageLayout>
  )
}
